export default "<p>workflow-job-logs-table works!</p>\n"